import React, { useState } from "react";
import "./partsorder.scss";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { downloadOrderWithDateRangeAction } from "../../actions/downloadAction";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";


function PartorderlistButtons({ fromDate, toDate }) {
  const [activeButton, setActiveButton] = useState(1);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();

  const parts = (buttonId) =>{
    setActiveButton(buttonId);
    navigate("/partslist")
  }
  const orders = (buttonId) =>{
    setActiveButton(buttonId);
    navigate("/partorderlist")
  }
  const partcatelogue = (buttonId) =>{
    setActiveButton(buttonId);
    navigate("/partcatelogue")
  }

  const handleDownloadOrder = () => {
    dispatch(downloadOrderWithDateRangeAction(fromDate, toDate))
  };

  const routerEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || "";
  const formattedRouteEndpoint = routerEndPoint.replace(/\/+$/, "");

  return (
    <div className="button-flex">
      <div className="partslistcatainersorders">
      {hasPermission(PERMISSIONS.CAN_VIEW_ORDERS) && (
          <button
          className={(window.location.pathname === `${formattedRouteEndpoint}/partorderlist` ? "AddpartsbulkAddpartsbulk" : "AddpartsbulkAddpartsbulk_s")}
          onClick={() => orders(2)}
        >{t('partlist.buttons.order')}</button>
        )}
        {hasPermission(PERMISSIONS.CAN_VIEW_PARTS) && (
          <button
          className={(window.location.pathname === `${formattedRouteEndpoint}/partslist` ? "AddpartsbulkAddpartsbulk" : "AddpartsbulkAddpartsbulk_s")}
          onClick={() => parts(1)}
        >{t('partlist.buttons.parts')}</button>
        )}
        {hasPermission(PERMISSIONS.CAN_VIEW_PART_CATALOGUES) && (
          <button
            className={(window.location.pathname === `${formattedRouteEndpoint}/partcatelogue` ? "AddpartsbulkAddpartsbulk" : "AddpartsbulkAddpartsbulk_s")}
            onClick={() => partcatelogue(3)}
          >{t('partlist.buttons.partcatelogue')}</button>
        )}
      </div>
      {window.location.pathname === `${formattedRouteEndpoint}/partorderlist` && (
        <div className="download-order-excel-btn">
          <button className="AddpartsbulkAddpartsbulk download-part-btn" disabled={!fromDate || !toDate} onClick={handleDownloadOrder}>
            {t("parts_list.downloadorder")}
          </button>
        </div>
      )}
    </div>
  );
}

export default PartorderlistButtons;
